export namespace ApiUtils {
  export const encodeDataToWWWFormUrlEncoded = <T extends NonNullable<unknown>>(
    data: T
  ): string => {
    return Object.entries(data)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            value as 'string | number | boolean'
          )}`
      )
      .join('&');
  };

  export const wwwFormUrlEncodedHeaders = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
}
